import { useState } from "react";

export const SilksIcon = ({ url, colours, testid }) => {
  const [broken, setBroken] = useState(false);
  return url && !broken ? (
    <img src={url} alt={colours ? `Racing silks: ${colours}` : "Racing silks"} title={colours || "Racing silks"} onError={() => setBroken(true)}
      className="w-8 h-8 object-contain shrink-0 rounded bg-white/5" loading="lazy" data-testid={testid} />
  ) : (
    <svg viewBox="0 0 24 24" className="w-8 h-8 shrink-0" role="img" aria-label="Generic silks icon, registered silks not available" data-testid={testid}>
      <title>Generic icon, registered silks not available</title>
      <path d="M8 3 4 5.5 2 10l3 1.5V21h14v-9.5l3-1.5-2-4.5L16 3c-.6 1.5-2.2 2.5-4 2.5S8.6 4.5 8 3Z"
        fill="none" stroke="#3B82F6" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
};
